// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__BY70z","projectsContainer":"Projects_projectsContainer__uXGtc","projects":"Projects_projects__JkzVY"};